import {
  FETCH_AVAILABLE_DAYS_BEGIN,
  FETCH_AVAILABLE_DAYS_SUCCESS,
  FETCH_AVAILABLE_DAYS_FAILURE,
} from '../actions/types';

const initialState = {
  dates: [],
  loading: false,
  error: null,
};

export default function availableDaysReducer(state = initialState, action) {
  switch (action.type) {
    case FETCH_AVAILABLE_DAYS_BEGIN:
      return {
        ...state,
        error: null,
        loading: true,
      };
    case FETCH_AVAILABLE_DAYS_SUCCESS:
      return {
        ...state,
        loading: false,
        dates: action.payload.dates,
      };
    case FETCH_AVAILABLE_DAYS_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload.error,
        dates: [],
      };
    default:
      return state;
  }
}
